import React from "react";
import { Box } from "@mui/material";

export default function Backdrop({ children, ay, ax }) {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: "0",
        minHeight: "100vh",
        height: "100%",
        width: "100%",
        display: "flex",
        backdropFilter: "blur(3px)",
        flexDirection: "column",
        justifyContent: ay === "bottom" ? "flex-end" : "center",
        alignItems: ax,
        // backgroundColor: "rgba(0, 0, 0,0.6)",
        backgroundColor: "rgba(0,0,30,0.4)",
        zIndex: "1000000",
      }}
    >
      <div style={{ width: "100%", maxWidth: "425px" }}>{children}</div>
    </Box>
  );
}
